/**
 * Represents the header information for a value option cascade.
 * Used to define relationships and ordering between source and header model values
 * in cascading option configurations.
 */
export class ValueOptionCascadeHdr {

  /**
   * Unique identifier for the value option cascade header, not to be displayed in UI..
   */
  id?: string | null;

  /**
   * Identifier for the source model value in the cascade relationship, not to be displayed in UI.
   */
  srcModelValueId?: string | null;

  /**
   * Identifier for the header model value in the cascade relationship, not to be displayed in UI.
   * This information must be made available accessible by the handsontable grid for proper operation.
   */
  hdrModelValueId?: string | null;

  /**
   * Sort order for the cascade header, used to determine the column order of display, this is a one based index.
   */
  sortOrder?: number | null;

  /**
   * Variable name associated with the cascade header, this should be used as the column header title
   */
  varName?: string | null;

  /**
   * array of available sorted options 
   */
  options?: string[] | null;
}

export class ValueOptionCascadeHdrHot extends ValueOptionCascadeHdr {

  /**
   *  Maps to val1-val10 index
   */
  originalIndex?: number; 

  
}
